import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

export const MarkdownListNumeric = ({ ordered: _ordered, ...props }: any) => {
  return React.createElement(`ol`, {
    className: clsx(styles.ol),
    ...props,
  });
};
